import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  dialogPaper: {
    position: "relative",
    maxWidth: 366,
    width: "100%"
  },
  dialogContent: {
    padding: 20
  },
  dialogActions: {
    display: "flex",
    justifyContent: "right",
    padding: "20px 0 0 0"
  },
  dialogTitle: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    height: 58,
    "& .MuiTypography-root": {
      fontWeight: "bold"
    }
  },
  addBoosterButton: {},
  addVaccineButton: {
    "&$addEntryButtonRoot": {
      border: "none"
    },
    "& $addEntryButtonLabel": {
      fontSize: 16
    }
  },
  addEntryButtonRoot: {
    borderRadius: 15,
    height: 30,
    borderColor: theme.palette.secondary.dark
  },
  addEntryButtonDisabled: {
    "& $addEntryButtonLabel": {
      color: theme.palette.text.disabled
    }
  },
  addEntryButtonLabel: {
    fontSize: 13,
    textTransform: "none",
    color: theme.palette.secondary.dark
  },
  buttonEditEntry: {
    color: theme.palette.text.secondary,
    fontWeight: "bold"
  }
}));
